import React from "react"
import { FaWhatsapp } from "react-icons/fa"

export default function WhatsAppButton() {
  const phoneNumber = "21697902051"

  const message = "Bonjour, je souhaiterais prendre rendez-vous pour un soin au spa."

  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactez-nous sur WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 shadow-2xl transition-all duration-300"
    >
      <FaWhatsapp className="text-white text-2xl" />
    </a>
  )
}